module.exports = __webpack_public_path__ + "img/1f997.ba9725e.svg";